import * as React from "react";
const SvgAddPlus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", width: 20, height: 20, viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.167 9.167v-5h1.666v5h5v1.666h-5v5H9.167v-5h-5V9.167z" }));
export default SvgAddPlus;
